var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"music"}},[_c('h1',[_vm._v("Music")]),_c('iframe',{attrs:{"width":"600","height":"600","scrolling":"no","frameborder":"no","src":_vm.playerUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }